var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWixByLogo = function SvgWixByLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24.41 9.45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "var(--fill-0, #333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.41 0H23.06c-.374 0-.723.185-.933.495l-1.804 2.66a.121.121 0 0 1-.2 0L18.321.495c-.21-.31-.56-.495-.934-.495H16.04l3.212 4.738-3.194 4.712h1.348c.374 0 .724-.185.934-.495l1.785-2.633a.121.121 0 0 1 .2 0l1.786 2.633c.21.31.56.495.934.495h1.348l-3.195-4.712L24.41 0ZM13.264.967V9.45h.645a.967.967 0 0 0 .966-.966V0h-.644a.967.967 0 0 0-.967.967ZM12.083 0h-.574c-.631 0-1.178.437-1.318 1.052l-1.283 5.64-1.123-5.265A1.79 1.79 0 0 0 5.558.08c-.651.18-1.133.73-1.274 1.39L3.172 6.685l-1.28-5.632A1.353 1.353 0 0 0 .573 0H0l2.15 9.45h.814c.739 0 1.377-.517 1.531-1.24L5.87 1.764a.175.175 0 0 1 .17-.138c.082 0 .154.058.17.138l1.376 6.448A1.566 1.566 0 0 0 9.116 9.45h.817L12.083 0Z"
  }))));
};
export default SvgWixByLogo;